var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3318 4.98966C19.5125 5.19741 19.7982 5.27995 20.0618 5.20056C20.597 5.03941 21.1189 4.84006 21.6238 4.60442C21.3026 5.1778 20.9009 5.70598 20.4285 6.17189C20.2621 6.33595 20.1886 6.57221 20.2324 6.80172C20.2765 7.03238 20.2992 7.26664 20.3 7.50149C20.2996 13.0059 17.6805 16.8854 14.0461 18.8199C11.0807 20.3982 7.39242 20.7063 3.8047 19.4852C5.43803 19.1694 7.00053 18.5248 8.39314 17.5795C8.60344 17.4367 8.71983 17.1912 8.69723 16.938C8.67462 16.6849 8.51656 16.4639 8.2843 16.3606C6.14623 15.4104 4.82195 14.1839 4.01325 12.907C3.20173 11.6257 2.88256 10.2508 2.82428 8.9685C2.76585 7.68319 2.97059 6.50556 3.19333 5.64431C3.21168 5.57334 3.23012 5.50465 3.24851 5.43834C4.19629 6.50022 5.33793 7.37756 6.61629 8.021C8.28967 8.86327 10.1454 9.27861 12.0181 9.23005C12.3975 9.22022 12.7 8.90982 12.7 8.53029V7.53029H12.7001L12.6999 7.52091C12.6896 6.74663 12.9172 5.98784 13.3521 5.34717C13.7871 4.7065 14.4082 4.21485 15.1317 3.93873C15.8551 3.6626 16.6459 3.61532 17.3971 3.80328C18.1483 3.99124 18.8237 4.40537 19.3318 4.98966Z",
    fill: "#2AA3D9",
    stroke: "#2AA3D9",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwActive);
export default __webpack_public_path__ + "static/media/tw-active.6d03a6a9748b4288a5e7b3480234e72c.svg";
export { ForwardRef as ReactComponent };